import { ConfigProvider, theme } from 'antd'
import { RouterProvider } from 'react-router-dom'
import router from './routes/index'
import { ThemeProvider, useThemeMode } from '@/theme/ThemeContext'
import { AuthProvider } from '@/context/AuthContext'
import { AdminAuthProvider } from '@/context/AdminAuthContext'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import ErrorBoundary from '@/components/ErrorBoundary'

const appFontFamily = "'PingFang SC', 'Microsoft YaHei', 'Inter', ui-sans-serif, system-ui, sans-serif"
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            retry: 1,
        },
    },
})

function AppContent() {
    const { isDarkMode } = useThemeMode()

    return (
        <ConfigProvider
            theme={{
                algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
                token: {
                    fontFamily: appFontFamily,
                },
            }}
        >
            <ErrorBoundary>
                <RouterProvider router={router}/>
            </ErrorBoundary>
        </ConfigProvider>
    )
}

export default function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <ThemeProvider>
                <AuthProvider>
                    <AdminAuthProvider>
                        <AppContent />
                    </AdminAuthProvider>
                </AuthProvider>
            </ThemeProvider>
        </QueryClientProvider>
    )
}
